module.exports = __webpack_public_path__ + "media/flags/tr-4361a465.svg";